import { ChangeDetectorRef, inject, signal } from '@angular/core';
import { AppStateService, HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { Router } from '@angular/router';
import { Station, StationTime } from '../../../models';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationSelectTime {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  appStateService = inject(AppStateService);
  router = inject(Router);
  changeRef = inject(ChangeDetectorRef);

  isLoading = signal(true);
  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedStation = this.stationsService.getSelectedStation();
  times: StationTime[] = [];
  selectedTime = this.stationsService.getSelectedTime();
  selectedFormatedTime: string | undefined;

  init() {
    if (this.selectedGroup) {
      this.findAllStations(this.selectedGroup.Id);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS]);
    }
  }

  findAllStations(groupId: number) {
    this.isLoading.set(true);
    this.stationsService.findAllStations(groupId).subscribe({
      next: (stations) => this.onStationsSuccess(stations),
      error: (err) => this.onStationsError(err),
    });
  }

  onStationsSuccess(stations: Station[]) {
    this.isLoading.set(false);
    if (this.selectedStation) {
      const selectedStation = stations.find((station) => station.Id === this.selectedStation!.Id);
      if (selectedStation) {
        this.selectedStation = selectedStation;
        this.stationsService.setSelectedStation(selectedStation);
        this.setTimes();
      }
    }
  }

  setTimes() {
    this.selectedStation?.AvailabilityCalendar.forEach((time) => {
      const [hours, minutes] = time.split('T')[1].split(':');
      const meridian = hours >= '12' ? 'PM' : 'AM';
      const hours12 = +hours % 12 || 12;
      this.times.push({
        time,
        formatedTime: `${hours12}:${minutes} ${meridian}`,
      });
    });

    const selectedFormatedTime = this.times.find((time) => time.formatedTime === this.selectedTime?.formatedTime);
    if (selectedFormatedTime) {
      this.selectedFormatedTime = selectedFormatedTime.formatedTime;
    }
    this.changeRef.detectChanges();
  }

  onStationsError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load stations');
  }

  onTimeClick() {
    const selectedTime = this.times.find((time) => time.formatedTime === this.selectedFormatedTime);
    if (selectedTime) {
      this.stationsService.setSelectedTime(selectedTime);
    }
  }
}